import { Component, Inject } from '@angular/core';
import { HOST } from 'src/app/tokens';

@Component({
	selector: 'app-trustedgoogle',
	templateUrl: './trustedgoogle.component.html',
	styleUrls: ['./trustedgoogle.component.scss']
})
export class TrustedGoogleComponent {

	constructor(
		@Inject(HOST) public host: string
	) {}

}
